import React from 'react';
import { Users, Lightbulb, Star, Heart, MapPin, CalendarDays, Building2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './AboutSection.css';

const VALUE_ICONS = [
  { icon: <Users size={22} />, color: 'var(--primary)', key: 'community' },
  { icon: <Lightbulb size={22} />, color: 'var(--secondary)', key: 'innovation' },
  { icon: <Star size={22} />, color: 'var(--accent)', key: 'quality' },
  { icon: <Heart size={22} />, color: '#10B981', key: 'passion' },
];

const STAT_ICONS = [
  { icon: <CalendarDays size={20} />, value: '1.000+', key: 'events' },
  { icon: <MapPin size={20} />, value: '50+', key: 'cities' },
  { icon: <Users size={20} />, value: '100%', key: 'free' },
  { icon: <Building2 size={20} />, value: '🇮🇹', key: 'made' },
];

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section id="about-section" className="about-root">

      {/* ── Header ── */}
      <div className="about-header">
        <span className="about-eyebrow">{t('about.eyebrow')}</span>
        <h2 className="about-title">
          {t('about.title_1')}<br />
          <span className="about-title-gradient">{t('about.title_2')}</span>
        </h2>
        <p className="about-subtitle">{t('about.subtitle')}</p>
      </div>

      {/* ── Stats bar ── */}
      <div className="about-stats">
        {STAT_ICONS.map((s, i) => (
          <div key={i} className="about-stat">
            <span className="about-stat-icon">{s.icon}</span>
            <span className="about-stat-value">{s.value}</span>
            <span className="about-stat-label">{t(`about.stats.${s.key}`)}</span>
          </div>
        ))}
      </div>

      {/* ── Story + Values ── */}
      <div className="about-body">

        {/* Story */}
        <div className="about-story-card">
          <div className="about-story-accent" />
          <h3 className="about-story-title">{t('about.story_title')}</h3>
          <p>{t('about.story_1')}</p>
          <p>{t('about.story_2')}</p>
          <p>{t('about.story_3')}</p>
        </div>

        {/* Values */}
        <div className="about-values-grid">
          {VALUE_ICONS.map((v, i) => (
            <div key={i} className="about-value-card">
              <div className="about-value-icon" style={{ background: `${v.color}18`, color: v.color }}>
                {v.icon}
              </div>
              <h4 className="about-value-title">{t(`about.values.${v.key}.label`)}</h4>
              <p className="about-value-text">{t(`about.values.${v.key}.text`)}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ── CTA ── */}
      <div className="about-cta">
        <p className="about-cta-text">{t('about.cta_text')}</p>
        <a href="#events-section" className="about-cta-btn"
          onClick={e => { e.preventDefault(); document.getElementById('events-section')?.scrollIntoView({ behavior: 'smooth' }); }}>
          {t('about.cta_btn')}
        </a>
      </div>

    </section>
  );
};

export default AboutSection;
